import { __decorate } from "tslib";
import Vue from "vue";
import Component from "vue-class-component";
let InstructorsTablePauseCell = class InstructorsTablePauseCell extends Vue {
};
InstructorsTablePauseCell = __decorate([
    Component
], InstructorsTablePauseCell);
export default InstructorsTablePauseCell;
